import React, { useEffect, useState } from "react";
import axios from "axios";

const OrderHistory = () => {
  const [orders, setOrders] = useState([]);
  const [mobile, setMobile] = useState("");
  const [staffMembers, setStaffMembers] = useState([]);
  const [couriers, setCouriers] = useState([]);

  // Fetch staff and couriers on mount
  useEffect(() => {
    const fetchInitialData = async () => {
      const token = localStorage.getItem("authToken");

      try {
        const [staffRes, courierRes] = await Promise.all([
          axios.get("https://astrovidhya.in/api/staff", {
            headers: { Authorization: `Bearer ${token}` },
          }),
          axios.get("https://astrovidhya.in/api/couriers", {
            headers: { Authorization: `Bearer ${token}` },
          }),
        ]);

        setStaffMembers(staffRes.data);
        setCouriers(courierRes.data);
      } catch (err) {
        console.error("❌ Error loading initial data:", err);
      }
    };

    fetchInitialData();
  }, []);

  const getCourierName = (courierId) => {
    const courier = couriers.find((c) => c._id === courierId);
    return courier ? courier.name : "No Courier Assigned";
  };

  // Listen for the custom event from OrderCreate
  useEffect(() => {
    const handleOrderFilter = (event) => {
      const { mobile, orders } = event.detail || {};
      setMobile(mobile);
      setOrders(orders || []);
    };

    const handleClear = () => {
      setOrders([]);
      setMobile("");
    };

    window.addEventListener("filterOrdersByMobile", handleOrderFilter);
    window.addEventListener("clearOrderList", handleClear);

    return () => {
      window.removeEventListener("filterOrdersByMobile", handleOrderFilter);
      window.removeEventListener("clearOrderList", handleClear);
    };
  }, []);

  const handleRowClick = (order) => {
    const courierName = getCourierName(order.courier);
    const callerName =
      staffMembers.find((staff) => staff._id === order.assigned_to)?.name || "Unassigned";
  
    // 🔥 Dispatch full order to OrderCreate
    window.dispatchEvent(
        new CustomEvent("orderSelected", {
          detail: {
            courierName,
            callerName,
            so: order.so || "",
            customer_name: order.customer_name || "",
            mobile: order.mobile || "",
            shipping_address: order.shipping_address || "",
            pin: order.pin || "",
            city: order.city || "",
            district: order.district || "",
            state: order.state || "",
            village: order.village || "",         // ✅ Add this line
            products: order.products || [],
            payment_method: order.payment_method || "",
            call_type: order.call_type || "",
            discount: order.discount || 0,
          },
        })
      );
      
  
    console.log("✅ Full order dispatched to populate form:", order);
  };
  

  return (
    <div className="order-list-container bg-white p-4 rounded-lg shadow-md">
      <h2 className="text-lg font-bold mb-4">
        Order History {mobile ? `for ${mobile}` : ""}
      </h2>

      {orders.length === 0 ? (
        <p className="text-gray-500">No previous orders found.</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="table-auto w-full border-collapse text-sm">
            <thead className="bg-gray-200">
              <tr>
                {[
                  "#",
                  "Order Date",
                  "Order No.",
                  "AWB No.",
                  "Customer Name",
                  "Mobile",
                  "Courier",
                  "Call Type",
                  "Approval Status",
                  "Order Time",
                  "Caller",
                  "Products",
                  "Discount (₹)",
                  "Total Amount",
                  "Payment Method",
                ].map((header) => (
                  <th
                    key={header}
                    className="px-4 py-2 text-left font-medium text-gray-700"
                  >
                    {header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {orders.map((order, index) => (
                <tr key={order._id} className="hover:bg-gray-100"  onClick={() => handleRowClick(order)} >
                  <td className="px-4 py-2">{index + 1}</td>
                  <td className="px-4 py-2">
                    {order.order_date
                      ? new Date(order.order_date).toLocaleDateString("en-US", {
                          year: "numeric",
                          month: "short",
                          day: "numeric",
                        })
                      : "N/A"}
                  </td>
                  <td className="px-4 py-2">{order.order_no || "N/A"}</td>
                  <td className="px-4 py-2">{order.awb || "N/A"}</td>
                  <td className="px-4 py-2">{order.customer_name || "N/A"}</td>
                  <td className="px-4 py-2">{order.mobile || "N/A"}</td>
                  <td className="px-4 py-2">{getCourierName(order.courier)}</td>
                  <td className="px-4 py-2">{order.call_type || "Not Set"}</td>
                  <td className="px-4 py-2">{order.approval_status || "Pending"}</td>
                  <td className="px-4 py-2">{order.order_time || "N/A"}</td>
                  <td className="px-4 py-2">
                    {staffMembers.find((s) => s._id === order.assigned_to)?.name ||
                      "Unassigned"}
                  </td>
                  <td className="px-4 py-2">
                    {Array.isArray(order.products) && order.products.length > 0
                      ? order.products
                          .map((p) => {
                            const productName = p.productName || "Unknown";
                            const price = p.price || 0;
                            return `${productName} (₹${price}) x${p.quantity}`;
                          })
                          .join(", ")
                      : "No Products"}
                  </td>
                  <td className="px-4 py-2">{order.discount || 0}</td>
                  <td className="px-4 py-2">₹{order.total_amount || 0}</td>
                  <td className="px-4 py-2">{order.payment_method || "N/A"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default OrderHistory;
